import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_136_head_name: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "137",
      action: "navigate_modulev1/heads_sub_group_add",
    },
    title: "Subgroup",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "group_name",
            Name: "ledger__sub_group",
            BindValue: "grid_emp",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/heads_sub_group_add/<id>",
                },
                ActionType: "Edit",
                ScreenId: "137",
              },
              {
                Action: {
                  Action: "Delete",
                  Module: "ledger__sub_group",
                },
                ActionType: "Delete",
                ScreenId: "136",
              },
            ],
            Form: {
              Name: "ledger__sub_group",
              TableName: "ledger_group",
              DisplayName: "Subgroup",
              Query:
                "SELECT lg.id, lg.group_name, COALESCE(u.username, NULLIF(TRIM(lg.created_by::text), '')) AS created_by, lg.created_at::date AS created_at FROM public.ledger_group lg LEFT JOIN users u ON u.id::text = TRIM(lg.created_by::text) WHERE lg.soft_delete = 0 AND lg.transaction_branch_id = '<branch_id>' ORDER BY lg.created_at DESC",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Group name",
                  BindValue: "name",
                  Json_Attribute: "group_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];

